import React from 'react';
import './Cart.css';

interface CartItem {
  id: string;
  name: string;
  price: string;
  image: string;
  quantity: number;
  stock?: number;
  cartItemId?: string;
}

interface CartProps {
  cartItems: CartItem[];
  onRemoveItem: (id: string) => void; // Changed to string
  onUpdateQuantity: (id: string, quantity: number) => void; // Changed to string
  onClose: () => void;
  onCheckout: () => void;
}

const Cart: React.FC<CartProps> = ({ cartItems, onRemoveItem, onUpdateQuantity, onClose, onCheckout }) => {
  const totalPrice = cartItems.reduce((total, item) => {
    return total + (parseFloat(item.price.replace('$', '').replace(',', '')) * item.quantity);
  }, 0);

  return (
    <div className="cart-overlay">
      <div className="cart-sidebar">
        <div className="cart-header">
          <h2>Your Cart</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <p>Your cart is empty</p>
            <p>Add some vintage pieces to get started!</p>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.name} className="cart-item-image" />
                  <div className="cart-item-info">
                    <h3>{item.name}</h3>
                    <p>{item.price}</p>
                    <div className="cart-item-controls">
                      <div className="quantity-controls">
                        <button
                          onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                          disabled={item.quantity <= 1}
                        >
                          -
                        </button>
                        <span>{item.quantity}</span>
                        <button 
                          onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                          disabled={item.stock !== undefined && item.quantity >= item.stock}
                          title={item.stock !== undefined && item.quantity >= item.stock ? 'Maximum stock reached' : ''}
                        >
                          +
                        </button>
                      </div>
                      {item.stock !== undefined && item.stock < 10 && (
                        <p className="stock-warning">Only {item.stock} left!</p>
                      )}
                      <button
                        className="remove-btn"
                        onClick={() => onRemoveItem(item.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-total">
              <p>Total: ${totalPrice.toFixed(2)}</p>
              <button className="checkout-btn" onClick={() => {
                onClose(); // Close cart
                onCheckout(); // Go to checkout
              }}>
                Proceed to Checkout
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
